import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { doNotDeleteDisputeApi } from '../../redux/slices/ReportAuditSlice';

function EditableTableRow({ row, index }) {
  const [isEditable, setIsEditable] = useState(false);
  const dispatch = useDispatch();

  const handleSaveClick = () => {
    setIsEditable(!isEditable);
    let obj = {
      id: row.id,
    };
    //console.log('eq=>', document.getElementById(`equifax-${index}`) && 1);
    if (document.getElementById(`equifax-${index}`) && 1) {
      obj.eq_deleted = document.getElementById(`equifax-${index}`)?.checked ? 0 : 1;
    }
    if (document.getElementById(`experian-${index}`) && 1) {
      obj.ex_deleted = document.getElementById(`experian-${index}`)?.checked ? 0 : 1;
    }
    if (document.getElementById(`transunion-${index}`) && 1) {
      obj.tr_deleted = document.getElementById(`transunion-${index}`)?.checked ? 0 : 1;
    }

    dispatch(doNotDeleteDisputeApi(obj));
  };

  return (
    <tr key={index}>
      <td>{row.account_name}</td>
      <td>{row.account_type}</td>
      <td>{row.account_status}</td>
      <td>
        <div className='d-flex align-items-center justify-content-center' style={{ gap: 3 }}>
          {row.experian}
          {row.experian != '' && (
            <label className='switch'>
              <input className='switch-input' type='checkbox' id={`experian-${index}`} name={`experian-${index}`} disabled={!isEditable} defaultChecked={row.ex_deleted == 1 ? false : true} />
              <span className='switch-label' data-on='Dispute' data-off='Do Not Dispute'></span>
              <span className='switch-handle'></span>
            </label>
          )}
        </div>
      </td>
      <td>
        <div className='d-flex align-items-center justify-content-center' style={{ gap: 3 }}>
          {row.equifax}
          {row.equifax != '' && (
            <label className='switch'>
              <input className='switch-input' type='checkbox' id={`equifax-${index}`} name={`equifax-${index}`} disabled={!isEditable} defaultChecked={row.eq_deleted == 1 ? false : true} />
              <span className='switch-label' data-on='Dispute' data-off='Do Not Dispute'></span>
              <span className='switch-handle'></span>
            </label>
          )}
        </div>
      </td>
      <td>
        <div className='d-flex align-items-center justify-content-center' style={{ gap: 3 }}>
          {row.transunion}
          {row.transunion != '' && (
            <label className='switch'>
              <input className='switch-input' type='checkbox' id={`transunion-${index}`} name={`transunion-${index}`} disabled={!isEditable} defaultChecked={row.tr_deleted == 1 ? false : true} />
              <span className='switch-label' data-on='Dispute' data-off='Do Not Dispute'></span>
              <span className='switch-handle'></span>
            </label>
          )}
        </div>
      </td>
      <td>
        {row.edit_value ? (
          isEditable ? (
            <span className='save-item' style={{ color: '#46464a' }} onClick={() => handleSaveClick()}>
              💾
            </span>
          ) : (
            <span class='pencilEmoji' style={{ color: '#46464a', cursor: 'pointer' }} onClick={() => setIsEditable(!isEditable)}>
              ✏️
            </span>
          )
        ) : null}
      </td>
    </tr>
  );
}

export default EditableTableRow;
